const scoreGradeUtils = {
  /* 匹配分制 */
  getMatched (scoreGrades = [], gradeBit, strict) {
    if (strict) {
      return scoreGrades.find(item => item.bit === gradeBit)
    } else {
      return scoreGrades.filter(item => (item.bit & gradeBit) !== 0)
    }
  },
  /* 匹配分数项 */
  getMatchOption (scoreGrade, matchScore) {
    if (typeof matchScore === 'number') {
      // 区间匹配
      if (scoreGrade && scoreGrade.options) {
        let current
        for (let i = 0; i < scoreGrade.options.length; i++) {
          let option = scoreGrade.options[i]
          let {maximum = 0, includeMax} = option
          if (matchScore === maximum && includeMax) {
            return option
          } else if (matchScore < maximum) {
            current = option
          } else {
            break
          }
        }
        return current
      }
    } else {
      // 名称匹配
      if (scoreGrade && scoreGrade.options) {
        return scoreGrade.options.find(option => option.name === matchScore)
      }
    }
  }
}

export default scoreGradeUtils
